import React, { FC } from "react";
import { Translate } from "../../components/translations";
import Section from "../../components/section";
import { PageHero } from "../../components/page-hero";
import Layout from "../../components/layout/layout";

const TermsOfUse: FC = () => (
  <div className="content-wrapper">
    <PageHero
      title="TERM_OF_USE_PAGE_TITLE"
      subtitle="TERM_OF_USE_PAGE_SUBTITLE"
    />
    <Layout>
      <Section>
        <div className="col-lg-12">
          <Translate name="TERM_OF_USE_PAGE_CONTENT_HEXOWATCH" />
        </div>
      </Section>
    </Layout>
  </div>
);

export default TermsOfUse;
